function normalizeWhitespace(text: string) {
	return text.replace(/\s+\n/g, "\n").replace(/\n\s+/g, "\n").trim()
}

// Strip HTML to text via DOMParser so <script>/<style> CONTENT is dropped
// (a plain tag-regex keeps their inner CSS/JS). Falls back to a tag-regex
// if DOMParser is unavailable (non-browser env).
function htmlToText(html: string): string {
	if (typeof DOMParser === "undefined") {
		return html.replace(/<[^>]+>/g, " ")
	}
	const doc = new DOMParser().parseFromString(html, "text/html")
	doc.querySelectorAll("script, style").forEach((node) => node.remove())
	return doc.body?.textContent ?? ""
}

export function getMailMessagePlainText({
	textBody,
	htmlBody,
}: {
	textBody?: string | null
	htmlBody?: string | null
}) {
	return normalizeWhitespace(
		textBody ||
			(htmlBody ? htmlToText(htmlBody) : "") ||
			"No message content available"
	)
}
